import React from 'react';
import Header from './common/Header';
import Footer from './common/Footer';
import astrologer from '../assets/astrologer.jpg';
import gamStar from '../assets/gam_star.png';

// Import SVG assets from HomePage
import frame20727501052 from '../assets/svg/frame-2072750105-2.svg';
import planetSvg from '../assets/svg/planet-svgrepo-com.svg';

// Import for test buttons
import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export default function About({ onNavigateToSignIn }) {
  // Test handler for GET API call
  const handleTestGet = async () => {
    const startTime = performance.now();
    console.group('🧪 [TEST] GET /api/test/get');
    console.log('⏱️ Start Time:', new Date().toISOString());
    console.log('🌐 Endpoint:', API_ENDPOINTS.TEST.GET);

    try {
      const response = await httpClient.get(API_ENDPOINTS.TEST.GET);
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(2);

      console.log('✅ Response:', response);
      console.log('📊 Status: Success');
      console.log('📦 Data:', response.data);
      console.log('⏲️ Duration:', `${duration}ms`);
      console.groupEnd();

      alert(`GET Test Successful!\nReceived: ${response.data.testValue}\nDuration: ${duration}ms`);
    } catch (error) {
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(2);

      console.error('❌ Error Status:', error.status);
      console.error('❌ Error Message:', error.message);
      console.error('❌ Error Data:', error.data);
      console.error('❌ Full Error:', error);
      console.log('⏲️ Duration:', `${duration}ms`);
      console.groupEnd();

      alert(`GET Test Failed!\nError: ${error.message}\nStatus: ${error.status}`);
    }
  };

  // Test handler for POST API call
  const handleTestPost = async () => {
    const startTime = performance.now();
    console.group('🧪 [TEST] POST /api/test/post');
    console.log('⏱️ Start Time:', new Date().toISOString());
    console.log('🌐 Endpoint:', API_ENDPOINTS.TEST.POST);

    const payload = {
      testName: "About Page Test",
      timestamp: new Date().toISOString(),
      testData: {
        string: "Hello World",
        number: 123,
        boolean: true,
        array: [1, 2, 3]
      },
      message: "This is a test POST request from About page"
    };

    console.log('📤 Request Payload:', payload);

    try {
      const response = await httpClient.post(API_ENDPOINTS.TEST.POST, payload);
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(2);

      console.log('✅ Response:', response);
      console.log('📊 Status: Success');
      console.log('📦 Received Data:', response.receivedData);
      console.log('📏 Data Size:', response.dataSize, 'fields');
      console.log('⏲️ Duration:', `${duration}ms`);
      console.groupEnd();

      alert(`POST Test Successful!\nData Size: ${response.dataSize} fields\nDuration: ${duration}ms`);
    } catch (error) {
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(2);

      console.error('❌ Error Status:', error.status);
      console.error('❌ Error Message:', error.message);
      console.error('❌ Error Data:', error.data);
      console.error('❌ Full Error:', error);
      console.log('⏲️ Duration:', `${duration}ms`);
      console.groupEnd();

      alert(`POST Test Failed!\nError: ${error.message}\nStatus: ${error.status}`);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFE99D] text-[#282828]">
      {/* NOTE: Make sure your tailwind config includes the following fonts:
          fontFamily: { philosopher: ['Philosopher', 'serif'], montserrat: ['Montserrat', 'sans-serif'] }
          Also add these colors if you prefer tokens, otherwise the hexes used below will work.
      */}

      {/* Hidden Testing Buttons - Access via console: document.getElementById('test-get-btn').click() */}
      <div style={{ display: 'none' }}>
        <button
          id="test-get-btn"
          onClick={handleTestGet}
          aria-label="Test GET API endpoint"
        >
          Test GET API
        </button>
        <button
          id="test-post-btn"
          onClick={handleTestPost}
          aria-label="Test POST API endpoint"
        >
          Test POST API
        </button>
      </div>

      <Header activePage="about" onNavigateToSignIn={onNavigateToSignIn} />

      {/* Section 1 - Hero / Meet your astrologer */}
      <section className="relative overflow-hidden">
	    <div className="decorative-star absolute top-[20px] right-[100px] md:top-[20px] md:right-[20px]">
          <img src={gamStar} alt="Decorative Star" className="gam-star" />
        </div>
        <div className="max-w-8xl mx-auto px-6 md:px-12 lg:px-20 pt-16 pb-12">
          <div className="text-center mb-10">
            <h1 className="font-philosopher text-2xl sm:text-[28px] lg:text-[56px] font-bold leading-tight block bg-gradient-to-r from-[#B21F25] to-[#6D1418] bg-clip-text text-transparent">
              Meet your astrologer
            </h1>

            {/* small divider */}
            <div className="mt-6 flex justify-center">
              <img
                src={frame20727501052}
                alt="Decorative divider"
                className="w-64 h-5"
                aria-hidden="true"
              />
            </div>
          </div>

          {/* Two column layout: image left (smaller), text right (larger)
              Left column width: 1/3 on large screens; Right column: 2/3
              Left content is center-aligned; right content is left-aligned
           */}
          <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
            {/* Left - fixed / smaller column */}
            <div className="w-full lg:w-2/5 flex-shrink-0 flex flex-col items-center text-center relative">
              {/* Wrapper to correctly position halo and image */}
              <div className="relative w-72 md:w-80 h-72 md:h-80 flex items-center justify-center">
                {/* Halo (background gradient circle) */}
                <div className="absolute md:w-96 md:h-96 rounded-full blur-3xl bg-gradient-to-br from-[#B21F25] to-[#F5B276] opacity-90 transform translate-y-0"></div>

                {/* Image (on top of halo) */}
                <div className="relative z-10 w-72 h-72 md:w-80 md:h-80 rounded-full overflow-hidden shadow-[0_30px_90px_rgba(178,31,37,0.12)]">
                  <img src={astrologer} alt="Dr. Suneel Kelkar" className="w-full h-full object-cover" />
                </div>
              </div>

              {/* Badges moved further down by 100px from the image */}
              <div className="flex flex-wrap gap-3 mt-[100px] justify-center z-10">
                <span className="inline-block bg-[#B21F25] text-white px-5 py-2 rounded-full text-sm font-semibold">35+ Years Experience</span>
                <span className="inline-block bg-[#B21F25] text-white px-5 py-2 rounded-full text-sm font-semibold">Gold Medalist (1991)</span>
                <span className="inline-block bg-[#B21F25] text-white px-5 py-2 rounded-full text-sm font-semibold">Honorary PhD (Sri Lanka)</span>
              </div>
            </div>

            {/* Right - larger column */}
            <div className="w-full lg:w-3/5 flex-1 max-w-4xl text-left">
              <h2 className="font-philosopher text-xl sm:text-[20px] lg:text-[40px] text-[#B21F25] font-bold mb-4">Dr. Suneel Kelkar</h2>

              <div className="space-y-5 font-montserrat text-[#525252] text-sm md:text-base leading-relaxed mb-6">
                <p>
                Dr. Suneel Kelkar, a respected Maharashtrian astrologer and scholar, has been serving people across India and abroad for over <strong>35 years</strong>. Continuing a family legacy of Jyotish, he is known for compassionate, accurate consultations — often offered <strong>free of charge</strong> as a form of social service. His approach blends traditional astrological wisdom with practical, actionable guidance.
                </p>

                <p>
                With postgraduate degrees in Commerce and Management, a <strong>Doctorate in Management (2009)</strong>, and a <strong>PhD in Water Resource Management (2014)</strong>, Dr. Kelkar brings a research-oriented perspective to astrology. He often applies statistical methods and case studies to refine predictive accuracy and evaluate the real-world impact of remedies.
                </p>

                <p>
                An accomplished teacher and mentor, he has conducted hundreds of workshops on chart interpretation, Mahadasha/Antardasha analysis, and integrating Vastu principles into modern spaces. His training emphasizes ethics, clarity, and reproducible techniques, enabling students to apply Jyotish thoughtfully in personal and professional contexts.
                </p>

                <p>
                A prolific author and speaker, Dr. Kelkar writes on astrology, career guidance, and the integration of traditional wisdom with modern decision-making. Known for his pragmatic, client-centered approach, he collaborates with counsellors and consultants to provide holistic guidance. He continues to mentor students, lead outreach initiatives, and promote responsible, accessible practice of Jyotish.
                </p>

              </div>

              {/* CTA buttons or other content can remain here */}
            </div>
          </div>
        </div>

        {/* subtle large star accents to match Figma */}
        <div className="hidden md:block absolute top-36 left-8 opacity-30">
          <img src={planetSvg} alt="" className="w-24 h-24 opacity-20" />
        </div>
      </section>

      {/* Section 2 - Red rounded "My specialities" section */}
      <section className="relative pt-16 -mt-6">
        <div className="bg-gradient-to-b from-[#B21F25] to-[#4C0D10] rounded-t-[72px] md:rounded-t-[90px] pt-20 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
            <div className="text-center mb-6">
              <h3 className="font-philosopher text-2xl sm:text-[28px] lg:text-[56px] text-white font-bold mb-4">Areas of expertise</h3>
              <div className="mb-6 flex justify-center">
                <img
                  src={frame20727501052}
                  alt="Decorative divider"
                  className="w-64 h-5 brightness-0 invert"
                  aria-hidden="true"
                />
              </div>

              <p className="font-montserrat text-white/90 text-base max-w-3xl mx-auto">
                Deep insights and practical guidance across astrology, Vastu and numerology.
              </p>
            </div>

            {/* cards grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 max-w-5xl mx-auto">
              {/* Card shared classes */}
              {[
                {
                  title: 'Vedic Astrology',
                  desc:
                    'Traditional Jyotish based readings for career, relationships, education, and life timing using your birth chart.',
                  icon: (
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#B21F25"><path d="M14 0L16.5 9.5L21.2 2.8L19 13L27 6.5L21 14L28 14L21 14L27 21.5L19 15L21.2 25.2L16.5 18.5L14 28L11.5 18.5L6.8 25.2L9 15L1 21.5L7 14L0 14L7 14L1 6.5L9 13L6.8 2.8L11.5 9.5L14 0Z"/></svg>
                  ),
                },
                {
                  title: 'Vastu Shastra',
                  desc:
                    'Practical Vastu guidance for homes and offices to create harmonious environments that support growth and well‑being.',
                  icon: (
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#B21F25"><path d="M3 3h22v22H3z"/></svg>
                  ),
                },
                {
                  title: 'Numerology',
                  desc:
                    'Name and number analysis to uncover personality patterns, career inclinations, and auspicious timings.',
                  icon: (
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#B21F25"><path d="M14 2a12 12 0 110 24A12 12 0 0114 2zm1 7h-2v7h2V9zm0 9h-2v2h2v-2z"/></svg>
                  ),
                },
                {
                  title: 'Career & Business Guidance',
                  desc:
                    'Career path analysis, timing for job changes, and strategic business planning informed by astrological insight.',
                  icon: (
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#B21F25"><path d="M23.333 7H18.667V4.667c0-1.284-1.05-2.334-2.334-2.334h-4.666c-1.284 0-2.334 1.05-2.334 2.334V7H4.667c-1.284 0-2.334 1.05-2.334 2.333v12.834c0 1.283 1.05 2.333 2.334 2.333h18.666c1.284 0 2.334-1.05 2.334-2.333V9.333c0-1.283-1.05-2.333-2.334-2.333zM11.667 4.667h4.666V7h-4.666V4.667zm11.666 17.5H4.667V9.333h18.666v12.834z"/></svg>
                  ),
                },
              ].map((c, idx) => (
                <article key={idx} className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 md:p-8 hover:bg-white/20 transition-all duration-300">
                  <div className="flex items-start gap-5">
                    <div className="bg-[#FFE99D] rounded-full p-3 flex-shrink-0">{c.icon}</div>
                    <div>
                      <h4 className="font-montserrat text-lg font-semibold text-white mb-2">{c.title}</h4>
                      <p className="font-montserrat text-white/90 text-sm leading-relaxed">{c.desc}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Awards & recognition */}
            <div className="mt-12 max-w-4xl mx-auto text-center">
              <h4 className="font-philosopher text-2xl text-white font-bold mb-4">Awards & Recognition</h4>
              <p className="font-montserrat text-white/90 text-sm leading-relaxed">
                Gold Medalist — National Astrology Examination (1991), Top Rank in Maharashtra Astrology Association (1995),
                and an Honorary PhD awarded by the Government of Sri Lanka for contributions to astrology and education.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 - Publications / Workshops / CTA */}
      <section className="bg-[#FFE99D] py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h3 className="font-philosopher text-xl sm:text-[20px] lg:text-[40px] font-bold bg-gradient-to-r from-[#B21F25] to-[#6D1418] bg-clip-text text-transparent mb-4">Let the stars guide your future</h3>

          <p className="font-montserrat text-[#525252] italic text-lg mb-6">Take the first step towards understanding your cosmic blueprint and unlocking your true potential.</p>

          <div className="mt-8">
            <a href="/consultation" className="inline-block bg-[#B21F25] text-white px-10 md:px-14 py-3 md:py-4 rounded-full text-sm md:text-base font-montserrat font-bold hover:opacity-90 hover:shadow-lg transition-all duration-300 uppercase tracking-wider">BOOK A READING</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
